module.exports = __webpack_public_path__ + "img/7.1661c4cc.png";